import { jsx as _jsx } from "react/jsx-runtime";
import { addErrorNotification, addInProgressItemsToOrder, addSuccessNotification, getAllowedPriceRestrictedOrderItemQuantity, getInProgressItem, isNonEmptyArray, NotificationType, setInProgressItemInitialValidation } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { ItemType } from '@vista-digital/ocapi-types/v1';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
import { getAllowedMaxQuantityForItem } from '../../../utils/items/get-allowed-max-quantity-for-item';
import { ItemModal } from '../../item-modal/item-modal';
import { ItemPickerContextInstance } from '../types/context';
import { ItemPickerModifierGroups } from './modifier-groups';
import { ItemPickerParentSalesOptions } from './parent-sales-options';
const b = bemClassBuilder('v-item-picker-item-modal');
export const ItemPickerItemModal = observer(props => {
    const { displayText, assets, config, cdnOptions, events } = useContext(ItemPickerContextInstance);
    const { readonly } = config;
    const { show, item, itemProfileButton, promotionLabel, getDisplayPrice, onClose } = props;
    const maximum = getAllowedMaxQuantityForItem(config.quantityLimit);
    const quantityLimit = Object.assign(Object.assign({}, config.quantityLimit), { isUnlimited: false, maximum });
    const itemModalProps = {
        readonly,
        sellableItem: itemProfileButton,
        show,
        onClose,
        getDisplayPrice,
        promotionLabel,
        imageCdnOptions: cdnOptions.itemImage,
        displayText,
        assets,
        config: Object.assign(Object.assign({}, config), { quantityLimit })
    };
    if (readonly) {
        return _jsx(ItemModal, Object.assign({}, itemModalProps, { readonly: true }));
    }
    const inProgressItem = getInProgressItem();
    if (!inProgressItem && show) {
        throw new Error('Cannot render item picker modal without an in-progress item');
    }
    const handleAddToCart = () => {
        var _a;
        try {
            addInProgressItemsToOrder();
            (_a = events.onItemAddedToCart) === null || _a === void 0 ? void 0 : _a.call(events, item);
            addSuccessNotification({
                id: getIdForComponentNotification('item-picker', NotificationType.Success, 'added-to-cart'),
                messages: [displayText.successfullyAddedItemToOrderMessage]
            });
            onClose(); // Close modal after adding to cart
        }
        catch (error) {
            addErrorNotification({
                id: getIdForComponentNotification('item-picker', NotificationType.Error, 'failed-to-validate-item-selections'),
                messages: [displayText.failedToValidateItemSelectionsMessage]
            }, error);
            setInProgressItemInitialValidation(false);
        }
    };
    const allowedMaximumForPriceRestrictedItem = getAllowedPriceRestrictedOrderItemQuantity(maximum, item.id, false);
    return (_jsx(ItemModal, Object.assign({}, itemModalProps, { className: b.block(), onAddToCart: handleAddToCart, allowedMaximumForPriceRestrictedItem: allowedMaximumForPriceRestrictedItem }, { children: getModalBody(inProgressItem, itemProfileButton) })));
});
ItemPickerItemModal.displayName = 'ItemPickerItemModal';
const getModalBody = (inProgressItem, itemProfileButton) => {
    if (!inProgressItem)
        return null;
    const { item } = inProgressItem;
    if (item.type === ItemType.Normal && isNonEmptyArray(item.modifierGroups)) {
        return _jsx(ItemPickerModifierGroups, { baseItem: itemProfileButton, modifierGroups: item.modifierGroups });
    }
    if (inProgressItem.type === ItemType.ParentSales) {
        return _jsx(ItemPickerParentSalesOptions, {});
    }
    return null;
};
